<template>
  <div class="my-4">
    <section
      v-if="ticket.offer_text"
      class="bg-topaz-light py-[10px] rounded-t-[5px]"
    >
      <p class="text-black text-center font-black text-[22px]">
        {{ ticket.offer_text }}
      </p>
    </section>
    <div
      class="w-full flex flex-col ticket-container p-9 relative"
      :class="{ selected: iframeStyles.selected && isExpand }"
      :style="getPersonalizedBox"
    >
      <div
        :id="'ticket-container-' + ticket.id"
        class="ticket-header flex"
        :class="canExpand ? 'cursor-pointer' : ''"
        @click="expandTicket(!isExpand)"
      >
        <div class="h-14 w-14 ticket-icon">
          <svg
            width="53"
            height="53"
            viewBox="0 0 53 53"
            fill="none"
            :alt="$t('wegow.altIcon')"
            class="h-14 w-14 ticket-icon"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M32.0208 20.8269C32.0208 20.2412 31.7882 19.6795 31.374 19.2653C30.9599 18.8512 30.3982 18.6185 29.8125 18.6185L25.3958 18.6185C24.8101 18.6185 24.2484 18.8512 23.8343 19.2653C23.4202 19.6795 23.1875 20.2412 23.1875 20.8269C23.1875 21.4126 23.4202 21.9742 23.8343 22.3884C24.2484 22.8025 24.8101 23.0352 25.3958 23.0352L29.8125 23.0352C30.3982 23.0352 30.9599 22.8025 31.374 22.3884C31.7882 21.9742 32.0208 21.4126 32.0208 20.8269ZM29.8125 47.3269C29.8125 47.9126 30.0452 48.4743 30.4593 48.8884C30.8734 49.3025 31.4351 49.5352 32.0208 49.5352L40.8542 49.5352C41.4399 49.5352 42.0015 49.3025 42.4157 48.8884C42.8298 48.4743 43.0625 47.9126 43.0625 47.3269L43.0625 7.57686C43.0625 6.99118 42.8298 6.42948 42.4157 6.01534C42.0016 5.60119 41.4399 5.36853 40.8542 5.36853L32.0208 5.36853C31.4351 5.36853 30.8734 5.60119 30.4593 6.01534C30.0452 6.42948 29.8125 6.99118 29.8125 7.57686C29.8125 8.16255 29.5798 8.72425 29.1657 9.13839C28.7516 9.55253 28.1899 9.7852 27.6042 9.7852C27.0185 9.7852 26.4568 9.55253 26.0426 9.13839C25.6285 8.72425 25.3958 8.16255 25.3958 7.57686C25.3958 6.99118 25.1632 6.42948 24.749 6.01534C24.3349 5.60119 23.7732 5.36853 23.1875 5.36853L14.3542 5.36853C13.7685 5.36853 13.2068 5.60119 12.7926 6.01533C12.3785 6.42948 12.1458 6.99118 12.1458 7.57686L12.1458 47.3269C12.1458 47.9126 12.3785 48.4743 12.7926 48.8884C13.2068 49.3025 13.7685 49.5352 14.3542 49.5352L23.1875 49.5352C23.7732 49.5352 24.3349 49.3025 24.749 48.8884C25.1632 48.4743 25.3958 47.9126 25.3958 47.3269C25.3958 46.7412 25.6285 46.1795 26.0426 45.7653C26.4568 45.3512 27.0185 45.1185 27.6042 45.1185C28.1899 45.1185 28.7515 45.3512 29.1657 45.7653C29.5798 46.1795 29.8125 46.7412 29.8125 47.3269ZM33.8317 46.2227C33.3675 44.9437 32.5207 42.7345 31.4066 41.9536C30.2924 41.1727 28.9648 40.7538 27.6042 40.7538C26.2436 40.7538 24.916 41.1727 23.8018 41.9536C22.6876 42.7345 21.8409 43.8396 21.3767 45.1185L15.4583 45.1185L15.4583 23.0352C14.3542 23.1883 17.7099 22.8025 18.124 22.3884C18.5382 21.9742 18.7708 21.4126 18.7708 20.8269C18.7708 20.2412 18.5382 19.6795 18.124 19.2653C17.7099 18.8512 16.044 18.6185 15.4583 18.6185L15.4583 9.13839L21.3767 9.13839C21.8409 10.4174 22.6876 12.1692 23.8018 12.9501C24.916 13.731 26.2436 14.1499 27.6042 14.1499C28.9648 14.1499 30.2924 13.731 31.4066 12.9501C32.5207 12.1692 33.3675 10.1293 33.8317 8.85035L40.0459 8.85035L40.0459 18.6185C39.4602 18.6185 37.4984 18.8512 37.0843 19.2653C36.6702 19.6795 36.4375 20.2412 36.4375 20.8269C36.4375 21.4126 36.6702 21.9742 37.0843 22.3884C37.4984 22.8025 39.4602 23.0352 40.0459 23.0352L40.0459 46.2227L33.8317 46.2227Z"
              :fill="
                getPersonalizedIcon.fill ? getPersonalizedIcon.fill : 'white'
              "
            />
          </svg>
        </div>
        <div class="flex flex-col justify-between ml-2 md:text-[20px]">
          <h3 :style="getPersonalizedTitle">{{ ticket.title }}</h3>
          <section class="flex gap-2">
            <del v-if="ticket.price_before_discount" class="text-priceGray">
              {{ formatCurrency(ticket.price_before_discount, event.currency) }}
            </del>
            <div :style="getPersonalizedPrice" class="price font-black">
              {{
                formatCurrency(
                  getTTPrice(
                    ticket.price,
                    ticket.insurance_premium,
                    ticket.insurance_type
                  ),
                  event.currency
                )
              }}
            </div>
          </section>
        </div>
        <img
          v-if="ticket.f2f"
          :src="require('@/assets/images/ic-weswap.svg')"
          :alt="ticket.title + '_weswap'"
          class="lazyload absolute top-0 right-0 m-4"
        />
        <div
          v-if="ticket.show_sold_out"
          :style="getPersonalizedBannerBox"
          class="absolute right-0 bottom-0 disabled-info px-4 py-1"
        >
          {{ $t("wegow.purchase.soldOut") }}
        </div>
        <div
          v-else-if="!canExpand"
          :style="getPersonalizedBannerBox"
          class="absolute right-0 bottom-0 disabled-info px-4 py-1"
        >
          {{
            ticket.reserved
              ? $t("wegow.purchase.reserved")
              : $t("wegow.purchase.soldOut")
          }}
        </div>
      </div>
      <div v-if="isExpand" class="expand-data pt-6">
        <p
          v-if="ticket.remaining > 0 && ticket.remaining <= 200"
          :style="getPersonalizedAuxColor"
          class="remaining mb-6"
        >
          {{
            $t("wegow.purchase.remaining", {
              remainingTickets: ticket.remaining
            })
          }}
        </p>
        <div v-if="ticket.f2f" class="flex flex-col mb-6">
          <p :style="getPersonalizedAuxColor" class="flex mb-6 weswap-info">
            <img
              :src="require('@/assets/images/ic-user-topaz.svg')"
              :alt="ticket.title + '_weswap'"
              class="lazyload mr-4"
            />
            {{ $t("wegow.purchase.weswap") }}
          </p>
          <div class="description" :style="getPersonalizedSubtitle">
            {{ $t("wegow.purchase.weswapDescription") }}
          </div>
        </div>
        <div class="description mb-2" :style="getPersonalizedSubtitle">
          {{ ticket.description }}
        </div>
        <hr
          v-if="canExpand"
          :style="getPersonalizedHr || getPersonalizedTicketButton"
        />
        <div
          v-if="canExpand"
          class="selector-container flex justify-center items-center mt-7"
        >
          <button
            :style="getPersonalizedTicketButton"
            class="btn round minus transparent"
            type="button"
            :disabled="ticket.selecteds === 0 || ticket.show_sold_out"
            @mouseover="e => getPersonalizedTicketButton"
            @click="minusTicket(ticket.id)"
          >
            -
          </button>
          <span
            :style="getPersonalizedPrice"
            class="quantity mx-6 font-black md:text-[30px]"
            >{{ ticket.selecteds }}</span
          >
          <button
            :style="getPersonalizedTicketButton"
            class="btn round more transparent"
            type="button"
            :disabled="isDisabled()"
            @mouseover="e => getPersonalizedTicketButton"
            @click="addTicket(ticket.id)"
          >
            +
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useEvent } from "@/composables/useEvent";
import { usePurchase } from "@/composables/usePurchase";
import { useIframeStyle } from "@/composables/useIframeStyle";

import { computed, ref, onMounted, onUnmounted } from "vue";
import { formatCurrency } from "@/plugins/currency";
import { INSURANCE_MANDATORY } from "@/constants";
import { useRoute } from "vue-router";

const { details: event, iframeStyles } = useEvent();
const route = useRoute();
const {
  maxNumberTicketByCode,
  actualPurchase,
  addTicket,
  minusTicket
} = usePurchase();
const {
  getPersonalizedTitle,
  getPersonalizedSubtitle,
  getPersonalizedPrice,
  getPersonalizedAuxColor,
  getPersonalizedHr,
  getPersonalizedTicketButton,
  getPersonalizedIcon,
  getPersonalizedBox,
  getPersonalizedBannerBox
} = useIframeStyle();
const props = defineProps({
  ticket: {
    type: Object,
    required: true
  },
  open: {
    type: Boolean,
    default: false
  },
  canOpentTicket: {
    type: Boolean,
    default: true
  }
});

const isExpand = ref(props.open);
const borderColor = ref("");
const canExpand = computed(() => {
  return !(props.ticket.available === 0);
});

onMounted(() => {
  borderColor.value = iframeStyles.value.card_border_color
    ? "2px solid " + iframeStyles.value.card_border_color
    : "unset";
});
const expandTicket = expand => {
  if (props.canOpentTicket) {
    if (expand) {
      isExpand.value = expand;
      let elemento = document.getElementById(
        "ticket-container-" + props.ticket.id
      );
      if (elemento) {
        var distanceToTop = 0;
        while (elemento) {
          distanceToTop += elemento.offsetTop;
          elemento = elemento.offsetParent;
        }
        const windowHeight = window.innerHeight;
        if (distanceToTop > windowHeight / 2) {
          const scrollToPosition = distanceToTop - windowHeight / 2;
          window.scrollTo({ top: scrollToPosition, behavior: "smooth" });
        }
      }
    } else {
      isExpand.value = expand;
    }
  }
};

const isDisabled = () => {
  let isDisabledVar = false;
  if (maxNumberTicketByCode.value > -1) {
    let total = 0;
    for (const ticketInPurchase of actualPurchase.value.selectedTickets) {
      total += ticketInPurchase.selecteds;
    }
    isDisabledVar = Boolean(total >= maxNumberTicketByCode.value);
  }
  if (!isDisabledVar) {
    let total = 0;
    for (const ticketInPurchase of actualPurchase.value.selectedTickets) {
      total += ticketInPurchase.selecteds;
    }
    isDisabledVar = Boolean(
      props.ticket.selecteds === props.ticket.max_tickets ||
        props.ticket.selecteds === event.value.max_tickets ||
        total === event.value.max_tickets ||
        props.ticket.selecteds === props.ticket.remaining ||
        props.ticket.selecteds === props.ticket.available ||
        props.ticket.show_sold_out
    );
  }

  return isDisabledVar;
};
const getTTPrice = (price, insurancePremium, insuranceType, quantity = 1) => {
  if (insuranceType === INSURANCE_MANDATORY) {
    return (Number(price) + Number(insurancePremium)) * quantity;
  } else return price * quantity;
};
</script>

<style lang="scss" scoped>
.ticket-container {
  background-color: $backgroundGrey;
  border-radius: 5px;
  &.selected {
    border: v-bind(borderColor);
  }
  .ticket-icon {
    margin-left: -8px;
  }
  .price,
  .weswap-info {
    color: $topaz;
  }
  .disabled-info {
    background-color: $textSubtitle;
    color: $backgroundGrey;
    border-radius: 5px 0px;
  }
  hr {
    border-top: 1px solid $backgroundLightGrey;
  }
  .description {
    color: $textSubtitle;
  }
  .remaining {
    color: $malva;
  }
  .minus,
  .more {
    width: 30px;
    height: 30px;
    border: 1px solid $topaz;
    border-radius: 100%;
    color: $topaz;
    cursor: pointer;
    &:hover:not(:disabled) {
      background-color: transparent;
      color: $backgroundGrey;
    }
    &:disabled {
      border-color: $backgroundLightGrey;
      color: $backgroundLightGrey;
      cursor: not-allowed;
      &:hover {
        border-color: $backgroundLightGrey;
        color: $backgroundLightGrey;
        cursor: not-allowed;
      }
    }
  }
}
</style>
